import { compose, branch, renderNothing, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import OEFilterButton from './OEFilterButton'
import { getOeFilterItems, getOeFilterMode } from './../../selectors'
import { activateOeFilter } from './../../actions'

const mapStateToProps = state => ({
  oeCount: getOeFilterItems(state).length,
  oeFilterMode: getOeFilterMode(state)
})

const withNoOeItemsAvailable = branch(
  ({ oeCount, oeFilterMode }) => !oeCount || Boolean(oeFilterMode),
  renderNothing
)

const withClickHandler = withHandlers({
  handleClick: ({ activateOeFilter }) => (e) => activateOeFilter()
})

export default compose(
  connect(mapStateToProps, { activateOeFilter }),
  withNoOeItemsAvailable,
  withClickHandler
)(OEFilterButton)
